import { Button, Stack } from '@mui/material';
import { PlusIcon } from '@phosphor-icons/react';

import { type api } from 'common';

import { ResponseFormatField } from './ResponseFormatField';
import { useReactFlowViewContext } from '../../../../context/context';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

function getDefaultResponseFormatField(): api.FlowDefinition.ResponseFormatField {
  return {
    fieldLabel: '',
    definition: '',
  };
}

interface ResponseFormatFieldsProps {
  fieldNamePrefix: string;
}

export function ResponseFormatFields(props: ResponseFormatFieldsProps) {
  const { fieldNamePrefix } = props;
  // Provide a default empty array if responseFormat is null or undefined from previously configured blocks
  const { value: responseFormat = [], setValue } = useSelectedNodeField<
    api.FlowDefinition.LlmPromptBlock['config']['responseFormat']
  >(`${fieldNamePrefix}.responseFormat`);
  const { isEditable } = useReactFlowViewContext();

  const { setValue: setMockData } = useSelectedNodeField<string | undefined>('mockData');

  return (
    <Stack gap={3}>
      {responseFormat.map((format, index) => {
        return (
          <ResponseFormatField
            key={index}
            fieldNamePrefix={`${fieldNamePrefix}.responseFormat[${index}]`}
            onDelete={() => {
              setValue(responseFormat.filter((_, i) => i !== index));
              setMockData('');
            }}
            values={format}
            fieldLabelFieldProps={{ label: `Field label ${index + 1}` }}
            definitionFieldProps={{ label: `Definition ${index + 1}` }}
          />
        );
      })}
      <Button
        variant="contained"
        onClick={() => {
          setValue([...responseFormat, getDefaultResponseFormatField()]);
          setMockData('');
        }}
        sx={{ alignSelf: 'flex-start', display: 'flex', gap: 1 }}
        disabled={!isEditable}
      >
        <PlusIcon size={12} />
        Add field
      </Button>
    </Stack>
  );
}
